import { ModelBase } from 'store/model-base';
import { TransactionType } from 'my-account/constants';

export class RelatedStatementTransaction extends ModelBase {
    public static storeName: string = 'relatedStatementTransactions';

    public id: Id;
    public type: TransactionType;
    public transactionDate: string;
    public amount: number;

    public isCredit: boolean;
    public isCreditReversal: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const transaction: RelatedStatementTransaction = super.create<RelatedStatementTransaction>(initData);

        transaction.isCredit = transaction.type === TransactionType.CREDIT;
        transaction.isCreditReversal = transaction.type === TransactionType.CREDIT_REVERSAL;

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> transaction;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }
}
